import { ZfIconButton, ZfPopover, ZfPopoverFooter, ZfPopoverHeader, ZfTextButton, ZfTypography } from '@zafire/react';
import type { ICellRendererParams } from 'ag-grid-enterprise';
import type { FunctionComponent } from 'react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import type { SurplusTableData } from '../../../interfaces/simulation-settings';

export const SurplusTableDeleteAction: FunctionComponent<ICellRendererParams<SurplusTableData>> = ({ data }) => {
    const { t } = useTranslation();
    const popoverRef = useRef<HTMLZfPopoverElement>(null);

    return (
        <ZfPopover ref={popoverRef} side="bottom" alignment="end" style={{ display: 'flex', alignItems: 'center' }}>
            <ZfIconButton slot="anchor" size="extra-small" icon="delete" hierarchy="tertiary" type="destructive" />
            <ZfPopoverHeader>{t('modalConfirmDeleteTitle')}</ZfPopoverHeader>
            <ZfTypography variant="label-extra-small" color="normal">
                {t('modalConfirmDeleteText')}
            </ZfTypography>
            <ZfPopoverFooter>
                <ZfTextButton hierarchy="tertiary" size="extra-small" onClick={() => popoverRef.current?.close()}>
                    {t('cancel')}
                </ZfTextButton>
                <ZfTextButton size="extra-small" kind="destructive" onClick={() => data?.onDelete()}>
                    {t('modalDeleteButton')}
                </ZfTextButton>
            </ZfPopoverFooter>
        </ZfPopover>
    );
};
